import React from 'react';
import styled from 'styled-components';
import themeGet from '@styled-system/theme-get';

const Container = styled.div`
  position: absolute;
  display: flex;
  align-items: center;
  background-color: white;
  border-radius: 20px;
  height: 2em;
  width: 2em;
  justify-content: space-around;
  justify-content: center;
  z-index: 2;
  right: 10px;
  top: 10px;

  i {
    color: ${themeGet('colors.primary.100')};
  }
`;

const CompleteIcon = () => (
  <Container>
    <i className='fa-light fa-circle-check fa-xl' />
  </Container>
);

export default CompleteIcon;
